<template>
  <div>
    <b-form-select v-model="selected" :options="options"></b-form-select>
  </div>
</template>

<script>

export default {
  name: "purchase-payment-status-select",
  props: {
    value: {
      type: [String, Array],
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
  },
  data() {
    return {
      selected: Array.isArray(this.value) ? this.value[0] : this.value || null,
      options: [
        { value: null, text: this.placeholder || this.$t('Please select {something}', { something: this.$t('tickets.customer_type') })},
        { value: 'paid', text: 'Lunas' },
        { value: 'partially', text: 'Kurang Bayar' },
        { value: 'overpaid', text: 'Lebih Bayar' },
      ]
    }
  },
  watch: {
    selected(val, oldVal) {
      if (val !== oldVal) {
        this.$emit('input', val);
      }
    },
    value(val){
      this.selected = val !== this.selected ? val ?? null : this.selected;
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event)
    },
    clearAll() {
      this.$emit('input', undefined)
    }
  }
}
</script>

<style scoped>

</style>
